exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".custom-object {\n  border: 1px solid #ededed;\n  border-radius: 10px;\n  padding: 5px;\n  margin-bottom: 10px;\n  background: rgba(240, 240, 240, 0.5); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/admin/shared/display-array-embedded/display-array-embedded.component.scss
// module id = 257
// module chunks = 0 1